const ALLOWED_TYPES = [
  'string',
  'number',
];

export default ALLOWED_TYPES;
